import { apiRequest } from 'platform/utilities/api';
import { DISABILITY_RATING_ACTIONS } from '../reducers/disabilityRating';
import { API_ENDPOINTS } from '../utils/constants';

const { STARTED, SUCCEEDED, FAILED } = DISABILITY_RATING_ACTIONS;

export const fetchTotalDisabilityRating = () => async (dispatch, getState) => {
  if (getState().disabilityRating.loading) return null;

  dispatch({ type: STARTED });

  try {
    const { data } = await apiRequest(API_ENDPOINTS.ratingInfo);
    dispatch({ type: SUCCEEDED, response: data.attributes });
    return data.attributes;
  } catch {
    dispatch({ type: FAILED });
    return null;
  }
};
